import React from "react";
import { ChevronDown } from "lucide-react";
import { CURRENCIES, currencySymbol, countryName, setCurrency, useCurrency } from "./currency";

export const CurrencySwitcher = ({ testId = "currency-switcher", dark = false, showHint = true }) => {
  const { currency, source, country } = useCurrency();
  const hint = source === "location" || source === "timezone" ? `Detected: ${countryName(country)}` : null;
  return (
    <div className="inline-flex items-center gap-3 flex-wrap">
      <label className="relative inline-flex items-center">
        <span className="sr-only">Display currency</span>
        <select
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
          data-testid={testId}
          className={`appearance-none rounded-none border min-h-[40px] pl-3 pr-8 py-2 font-mono text-[11px] uppercase tracking-[0.18em] cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-signal ${
            dark ? "bg-ink text-paper border-paper/40 hover:border-paper" : "bg-paper text-ink border-ink hover:bg-surface"
          }`}
        >
          {CURRENCIES.map((c) => (
            <option key={c} value={c}>
              {currencySymbol(c) === c ? c : `${c} ${currencySymbol(c)}`}
            </option>
          ))}
        </select>
        <ChevronDown size={12} className="pointer-events-none absolute right-2.5" />
      </label>
      {showHint && hint && (
        <span className={`font-mono text-[10px] uppercase tracking-[0.18em] ${dark ? "text-paper/75" : "text-ink2"}`} data-testid={`${testId}-hint`}>
          {hint}
        </span>
      )}
    </div>
  );
};

export const PriceNote = ({ dark = false, className = "" }) => {
  const { currency } = useCurrency();
  return (
    <p className={`font-mono text-[10px] uppercase tracking-[0.18em] ${dark ? "text-paper/75" : "text-ink2"} ${className}`} data-testid="price-note">
      Prices shown in {currency} are approximate. Billed in USD.
    </p>
  );
};
